/**
 * Ponto de entrada do app.
 *
 * `StrictMode` fica ligado de propósito: ele monta, desmonta e remonta em
 * desenvolvimento, e é exatamente esse ciclo que revela efeito sem limpeza —
 * sessão duplicada, WebSocket órfão, temporizador vivo depois da desmontagem.
 * O bootstrap de sessão é idempotente (ver `client/session.ts`) justamente
 * para atravessar esse ciclo sem criar duas sessões.
 *
 * O `LoginGate` fica **fora** do `App`, e não dentro dele. É a diferença entre
 * "o app monta e depois descobre quem é" e "o app só existe depois de haver
 * identidade": o `App` abre sessão e stream no primeiro efeito, e desde a v0.2
 * uma sessão sem tenant não é uma sessão degradada — é um 401. Montar o app
 * antes do login renderia um erro na tela em toda primeira carga.
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { LoginGate } from './auth';
import App from './App';

const raiz = document.getElementById('root');
if (!raiz) {
  throw new Error('elemento #root não encontrado — o index.html mudou?');
}

createRoot(raiz).render(
  <StrictMode>
    <LoginGate>
      <App />
    </LoginGate>
  </StrictMode>,
);
